import {Typography} from '@mui/material';
import {useEffect, useState} from 'react';
import {useMutation, useQueryClient} from 'react-query';
import {useDispatch} from 'react-redux';
import CustomisedButton from '../../../../components/button/button';
import LoanCard from '../../../../components/card/loanCard/loanCard';
import EmptyStyle from '../../../../components/emptyStyles/emptyStyle';
import {useAuth} from '../../../../config/AuthProvider/authProvider';
import {
    LOANS_INFO,
    PAYMENT_ID,
    REPAYMENT_TYPE,
} from '../../../../config/cacheKey';
import {IGetLoansResponse} from '../../../../models/registration.model';
import {getNextInnerState} from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import {setHeaderTitle} from '../../../../redux/headerTitle/headerTitleSlice';
import {getpervStateTab} from '../../../../redux/loansTab/loansTabSlice';
import {GetLoans} from '../../../../services/loan.service';
import LoansSkeleton from './loansSkeleton';
import EmptyLoanStyle from '../../../../components/icons/EmptyLoanStyle';

export default function Loans() {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const {setRefKey} = useAuth();
    const handleRegister = () => {
        setRefKey(null);
        dispatch(getpervStateTab({prevState: 'appContainer'}));
    };
    const handleInProgressLoan = (ref: string, loanTemplateKey: string) => {
        setRefKey(ref);
        dispatch(getNextInnerState({nextInnerState: 'handleloanDetail'}));
        dispatch(getpervStateTab({prevState: 'loanDetail'}));
        queryClient.setQueryData('LOAN_TEMPLATE_KEY', loanTemplateKey);
    };

    const handleCanceldLoans = (loan: IGetLoansResponse) => {
        setRefKey(loan.referenceKey);
        queryClient.setQueryData(LOANS_INFO, loan);
        localStorage.setItem('LOANS_INFO', JSON.stringify(loan));
        queryClient.setQueryData<{
            cancellationReasons: string[];
            cancelDescription: string;
        }>('CANCLE_REASONS', {
            cancelDescription: loan.cancelDescription,
            cancellationReasons: loan.cancellationReasons,
        });
        dispatch(getNextInnerState({nextInnerState: 'CanceledLoans'}));
        dispatch(getpervStateTab({prevState: 'installment'}));
    };
    type TStatus = 'Assigned' | 'Settled';
    const statusCardClass: Record<TStatus, string> = {
        Assigned: '#FDFEFE',
        Settled: '#FAFBFD',
    };
    const handleLoan = (
        ref: string,
        loanRequestStatus: string,
        repaymentType: string,
        item: IGetLoansResponse
    ) => {
        queryClient.setQueryData(REPAYMENT_TYPE, repaymentType);
        localStorage.setItem(REPAYMENT_TYPE, repaymentType);
        queryClient.setQueryData(LOANS_INFO, item);
        localStorage.setItem('LOANS_INFO', JSON.stringify(item));

        setRefKey(ref);
        //Check it

        if (repaymentType == 'InstallmentCheque') {
            dispatch(getpervStateTab({prevState: 'InstallmentCheque'}));
            dispatch(getNextInnerState({nextInnerState: 'installmentCheque'}));
        } else {
            dispatch(getpervStateTab({prevState: 'installment'}));
            dispatch(
                setHeaderTitle({
                    color: statusCardClass[item.loanRequestStatus as TStatus],
                    header: 'پرداخت اقساط',
                    parentRoute: 'AssignedLoans',
                })
            );
        }
    };
    const [dataInProgrress, setDataInProgrress] =
        useState<IGetLoansResponse[]>();
    const [dataNotInProgress, setDataNotInProgress] =
        useState<IGetLoansResponse[]>();
    const [canceledLoans, setCanceledLoans] = useState<IGetLoansResponse[]>();
    const {mutateAsync: getLonas, isLoading} = useMutation(GetLoans, {
        onSuccess: (data: IGetLoansResponse[]) => {
            const dataInProgrress = data.filter(
                (item) => item.inProgress === true
            );
            const dataNotInProgress = data.filter(
                (item) =>
                    item.inProgress === false &&
                    item.loanRequestStatus !== 'CanceledBySetad'
            );
            setDataInProgrress(dataInProgrress);
            setDataNotInProgress(dataNotInProgress);
            setCanceledLoans(
                data.filter(
                    (loan) => loan.loanRequestStatus === 'CanceledBySetad'
                )
            );
        },
    });
    useEffect(() => {
        dispatch(getNextInnerState({nextInnerState: `AssignedLoans`}));
        queryClient.setQueryData(REPAYMENT_TYPE, '');
        localStorage.setItem(REPAYMENT_TYPE, '');
        dispatch(setHeaderTitle({display: 'none'}));
        getLonas();
        queryClient.setQueryData(PAYMENT_ID, 0);
        //route from kaman
        const newCleanUrl = `${window.location.origin}/#/`;
        window.history.replaceState(null, '', newCleanUrl);
    }, []);

    if (isLoading) {
        return <LoansSkeleton />;
    }
    return (
        <div
            style={{height: '100%'}}
            className="content-container p-5 mt-5 !h-[calc(100svh-60px)]"
        >
            <div style={{overflowY: 'auto'}}>
                {
                    (dataInProgrress && dataInProgrress!.length > 0) ||
                    (dataNotInProgress && dataNotInProgress!.length) ||
                    (canceledLoans && canceledLoans!.length) ? (
                        <>
                            {dataInProgrress?.map((item, index) => (
                                <LoanCard
                                    key={index}
                                    // status={item?.loanRequestStatus}
                                    status={'other'}
                                    onClick={() =>
                                        handleInProgressLoan(
                                            item.referenceKey,
                                            item?.loanTemplateKey
                                        )
                                    }
                                    price={String(
                                        item?.amount.toLocaleString()
                                    )}
                                    financialProvider={
                                        item?.financialSupplierTitle
                                    }
                                    financialSupplierLogoUrl={
                                        item?.financialSupplierLogoUrl
                                    }
                                    insallmentStep={item?.durationTitle}
                                    inProgress={String(item?.inProgress)}
                                    statusTitle={item?.loanRequestStatusTitle}
                                />
                            ))}
                            <>
                                {dataNotInProgress &&
                                    dataNotInProgress!.length > 0 && (
                                        <>
                                            <div className="!mb-3">
                                                <Typography
                                                    sx={{
                                                        fontSize: '14px',
                                                        marginRight: '10px',
                                                    }}
                                                    className="primaryColorLight-900 "
                                                >
                                                    تسهیلات تخصیص داده شده{' '}
                                                </Typography>
                                            </div>
                                            {dataNotInProgress?.map(
                                                (item, index) => (
                                                    <LoanCard
                                                        key={index}
                                                        status={
                                                            item?.loanRequestStatus
                                                        }
                                                        onClick={() =>
                                                            handleLoan(
                                                                item.referenceKey,
                                                                item.loanRequestStatus,
                                                                item.repaymentType,
                                                                item
                                                            )
                                                        }
                                                        price={String(
                                                            item?.amount.toLocaleString()
                                                        )}
                                                        financialProvider={
                                                            item?.financialSupplierTitle
                                                        }
                                                        financialSupplierLogoUrl={
                                                            item?.financialSupplierLogoUrl
                                                        }
                                                        insallmentStep={
                                                            item?.durationTitle
                                                        }
                                                        inProgress={
                                                            item?.financialSupplierTitle
                                                        }
                                                        statusTitle={
                                                            item?.loanRequestStatusTitle
                                                        }
                                                    />
                                                )
                                            )}
                                        </>
                                    )}
                            </>
                            <>
                                {canceledLoans?.length! > 0 && (
                                    <div className="!mb-3">
                                        <Typography
                                            sx={{
                                                fontSize: '14px',
                                                marginRight: '10px',
                                            }}
                                            className="primaryColorLight-900 "
                                        >
                                            تسهیلات لغو شده
                                        </Typography>
                                    </div>
                                )}
                                {canceledLoans?.map((loan, index) => (
                                    <LoanCard
                                        key={index}
                                        status={'CanceledBySetad'}
                                        onClick={() => handleCanceldLoans(loan)}
                                        price={String(
                                            loan?.amount.toLocaleString()
                                        )}
                                        financialProvider={
                                            loan?.financialSupplierTitle
                                        }
                                        financialSupplierLogoUrl={
                                            loan?.financialSupplierLogoUrl
                                        }
                                        insallmentStep={loan?.durationTitle}
                                        inProgress={String(loan?.inProgress)}
                                        statusTitle={
                                            loan?.loanRequestStatusTitle
                                        }
                                    />
                                ))}
                            </>
                        </>
                    ) : (
                        <EmptyStyle
                            icon={
                                <EmptyLoanStyle className="mt-10 text-center text-[var(--primary-text-color)]" />
                            }
                            text={'تاکنون درخواست تسهیلاتی  ثبت نشده است.'}
                            emphasisedWords={['تسهیلاتی  ثبت نشده']}
                            emphasisedWordsColor={'#BBA57A'}
                        />
                    )

                    // <EmptyStyleLoans />
                }
            </div>
            <div className="py-5 sm:pt-4 pb-8">
                <CustomisedButton
                    title={'ثبت درخواست تسهیلات جدید'}
                    disable={false}
                    onClick={handleRegister}
                    type="submit"
                />
            </div>
        </div>
    );
}
